import Vue from 'vue';

import { RestComponent } from '../../../mixins/rest-component';
import { TranslatedComponent } from '../../../mixins/translated-component';
import template from './page-hompage.vhtml';

export const PageHomepage = Vue.component( 'my-page-homepage', {
	mixins: [ RestComponent, TranslatedComponent ],
	template: template,
	props: {
		siteData: {
			type: Object,
			default: () => {},
		},
		appLoaded: {
			type: Boolean,
			default: false,
		}
	},
	data: () => ({
		contentScrollPosition: 0
	}),
	methods: {
		filterContent: function( content ) {
			return content
				.map( item => Object.assign( {}, item, { link: fixLink( item.link ) } ) );
		},
		handleContentScroll: function (e) {
			this.contentScrollPosition = e.target.scrollTop;
		}
	}
});

/**
 * Remove the domain and protocol from the link
 * @param {string} link 
 */
function fixLink(link) {
	return link.replace(/https?:\/\/[^\.]+\.[^\/]+\//, '');
}



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-homepage/page-homepage.js